/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './order-item-quantity-control.component';
import * as import2 from '../../../inputs/quantity-control/quantity-control.component.ngfactory';
import * as import3 from '../../../inputs/quantity-control/quantity-control.component';
import * as import4 from '../../../orchestration/session.model';
import * as import5 from '../../order.model';
import * as import6 from '../../../notification/notification.service';
const styles_OrderItemQuantityControlComponent:any[] = ([] as any[]);
export const RenderType_OrderItemQuantityControlComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderItemQuantityControlComponent,
  data: {}
}
);
export function View_OrderItemQuantityControlComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-quantity-control',([] as any[]),(null as any),[
      [
        (null as any),
        'onDecrement'
      ]
      ,
      [
        (null as any),
        'onIncrement'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.OrderItemQuantityControlComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onDecrement' === en)) {
        const pd_1:any = ((<any>co.decrementQuantity()) !== false);
        ad = (pd_1 && ad);
      }
      if (('onIncrement' === en)) {
        const pd_2:any = ((<any>co.incrementQuantity()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import2.View_QuantityControlComponent_0,import2.RenderType_QuantityControlComponent)),
    import0.ɵdid(49152,(null as any),0,import3.QuantityControlComponent,[import4.SessionModel],{
      decrementUnavailable: [
        0,
        'decrementUnavailable'
      ]
      ,
      incrementUnavailable: [
        1,
        'incrementUnavailable'
      ]
      ,
      quantity: [
        2,
        'quantity'
      ]
      ,
      transparent: [
        3,
        'transparent'
      ]
      ,
      readOnly: [
        4,
        'readOnly'
      ]

    }
    ,{
      onDecrement: 'onDecrement',
      onIncrement: 'onIncrement'
    }
    ),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import1.OrderItemQuantityControlComponent = v.component;
    const currVal_0:boolean = !co.canDecrement;
    const currVal_1:boolean = !co.canIncrement;
    const currVal_2:any = co.orderItem.quantity;
    const currVal_3:any = co.transparent;
    const currVal_4:any = co.orderItem.deal;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderItemQuantityControlComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-item-quantity-control',[[
        'class',
        'quantity'
      ]
    ],(null as any),(null as any),(null as any),View_OrderItemQuantityControlComponent_0,RenderType_OrderItemQuantityControlComponent)),
    import0.ɵdid(49152,(null as any),0,import1.OrderItemQuantityControlComponent,[
      import5.OrderModel,
      import6.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderItemQuantityControlComponentNgFactory:import0.ComponentFactory<import1.OrderItemQuantityControlComponent> = import0.ɵccf('woa-order-item-quantity-control',import1.OrderItemQuantityControlComponent,View_OrderItemQuantityControlComponent_Host_0,{
  orderItem: 'orderItem',
  originalOrderItem: 'originalOrderItem',
  transparent: 'transparent',
  disabled: 'disabled'
}
,{quantityChanged: 'quantityChanged'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItaXRlbS9vcmRlci1pdGVtLXF1YW50aXR5LWNvbnRyb2wvb3JkZXItaXRlbS1xdWFudGl0eS1jb250cm9sLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL29yZGVyL29yZGVyLWl0ZW0vb3JkZXItaXRlbS1xdWFudGl0eS1jb250cm9sL29yZGVyLWl0ZW0tcXVhbnRpdHktY29udHJvbC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL29yZGVyL29yZGVyLWl0ZW0vb3JkZXItaXRlbS1xdWFudGl0eS1jb250cm9sL29yZGVyLWl0ZW0tcXVhbnRpdHktY29udHJvbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItaXRlbS9vcmRlci1pdGVtLXF1YW50aXR5LWNvbnRyb2wvb3JkZXItaXRlbS1xdWFudGl0eS1jb250cm9sLmNvbXBvbmVudC50cy5PcmRlckl0ZW1RdWFudGl0eUNvbnRyb2xDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8d29hLXF1YW50aXR5LWNvbnRyb2wgW2RlY3JlbWVudFVuYXZhaWxhYmxlXT1cIiFjYW5EZWNyZW1lbnRcIiAob25EZWNyZW1lbnQpPVwiZGVjcmVtZW50UXVhbnRpdHkoKVwiXG4gICAgICAgICAgICAgICAgICAgICAgW2luY3JlbWVudFVuYXZhaWxhYmxlXT1cIiFjYW5JbmNyZW1lbnRcIiAob25JbmNyZW1lbnQpPVwiaW5jcmVtZW50UXVhbnRpdHkoKVwiXG4gICAgICAgICAgICAgICAgICAgICAgW3F1YW50aXR5XT1cIm9yZGVySXRlbS5xdWFudGl0eVwiIFtyZWFkT25seV09XCJvcmRlckl0ZW0uZGVhbFwiXG4gICAgICAgICAgICAgICAgICAgICAgW3RyYW5zcGFyZW50XT1cInRyYW5zcGFyZW50XCI+PC93b2EtcXVhbnRpdHktY29udHJvbD5cbiIsIjx3b2Etb3JkZXItaXRlbS1xdWFudGl0eS1jb250cm9sPjwvd29hLW9yZGVyLWl0ZW0tcXVhbnRpdHktY29udHJvbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBNkQ7UUFBQTtRQUFBO01BQUE7TUFDQTtRQUFBO1FBQUE7TUFBQTtNQUQ3RDtJQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBR3lFOzs7O0lBSG5EO0lBQ0E7SUFDQTtJQUNBO0lBRGdDO0lBRnRELFNBQXNCLFVBQ0EsVUFDQSxVQUNBLFVBRGdDLFNBRnREOzs7OztNQ0FBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7SUFBQTtLQUFBOzs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-quantity-control/order-item-quantity-control.component.ngfactory.ts